<template>
  <div class="as-emp-res-assigment-header">
    <div class="as-emp-res-left">
      <ResponsibilityAssignmentHeader
        class="as-res-header"
        :responsibilityCode="responsibility.responsibilityCode"
        :responsibilityName="responsibilityName"
        :responsibilityImportance="responsibility.responsibilityImportance"
        :roleCode="responsibility.roleCode"
        :roleName="roleName"
        :roleImportance="responsibility.roleImportance"
        :positionCode="responsibility.positionCode"
        :positionName="positionName"
        :positionImportance="responsibility.positionImportance"
        :positionCommitment="responsibility.positionCommitment"
        :assignedOn="assignedOn"
        :newDuration="responsibility.newDuration"
        :show_codes="responsibility.show_codes"
      />
    </div>
    <div class="as-emp-res-right">
      <ReadinessBadge
        class="as-emp-readiness"
        :level="readinessLevel"
        :dot="'No Dot'"
        :view="'Null'"
      />
      <div class="as-ins-people">
        <span class="avail-ins" v-if="availableInspectors.length > 0">Available Inspectors:</span>
        <PeopleAvatarsButton
          v-if="availableInspectors.length > 0"
          :avatars="availableInspectors"
          :isShowTooltip="true"
          :size="'medium'"
          :allowDrillDown="false"
        />
        <InspectionIssueBadge
          :currentBadgeLevel="readinessLevel ? readinessLevel.toLowerCase() : 'novice'"
          :checkpoints="inspectionStatus ? inspectionStatus : []"
          :currentBadgeStatus="getBadgeStatusForInspection(currentBadgeStatus)"
          :useCountsVariant="!!checkpointCounts && Object.keys(checkpointCounts).length > 0"
          :checkpointCounts="checkpointCounts || {}"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import ReadinessBadge from '@components/ReadinessBadge/ReadinessBadge.vue';
import InspectionIssueBadge from "@components/InspectionIssueBadge/InspectionIssueBadge.vue";
import PeopleAvatarsButton from '@components/PeopleAvatarsButton/PeopleAvatarsButton.vue';
import ResponsibilityAssignmentHeader from "@components/ResponsibilityAssignmentHeader/ResponsibilityAssignmentHeader.vue";

const props = defineProps({
  responsibility: {
    type: Object,
    default: () => ({})
  },
  responsibilityName: {
    type: String,
    default: ""
  },
  roleName: {
    type: String,
    default: ""
  },
  positionName: {
    type: String,
    default: ""
  },
  assignedOn: {
    type: String,
    default: ""
  },
  availableInspectors: {
    type: Array,
    default: () => []
  },
  inspectionStatus: {
    type: Array,
    default: () => []
  },
  checkpointCounts: {
    type: Object,
    default: () => ({})
  },
  currentBadgeStatus: {
    type: String,
    default: ""
  },
  currentBadgeStatus: {
    type: String,
    default: "good_standing"
  },
  readinessLevel: {
    type: String,
    default: "Apprentice"
  },
  readinessDot: {
    type: String,
    default: "No Dot"
  }
});
const getBadgeStatusForInspection = (status) => {
  // Map the badge status to what InspectionIssueBadge component expects
  if (status === "given") {
    return "forced";
  } else if (status === "good_standing") {
    return "good_standing";
  } else if (status === "awarded") {
    return "good_standing"; // Map awarded to good_standing
  } else if (status === "obsolete") {
    return "obsolete";
  } else {
    return "null"; // default fallback
  }
};
</script>

<style>
.as-emp-res-assigment-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  gap: 12px;
}
.as-emp-res-left {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0; /* Required for ellipsis */
}
.as-res-header {
  flex: 1;
  min-width: 0; /* Required for ellipsis */
}
.as-emp-res-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
  gap: 6px;
}
.as-emp-readiness {
  position: relative;
  right: 7px;
}
.as-ins-people {
  display: flex;
  align-items: center;
}
.as-ins-people .avail-ins {
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #101828;
  white-space: nowrap;
  position: relative;
  left: -10px;
}
.responsibility-name,
.role-name,
.position-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 100%;
  vertical-align: middle;
}
.as-ins-people .people-button {
  left: -5px;
}
</style>
